import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CapabilitiesSection from './components/CapabilitiesSection';
import ScenariosSection from './components/ScenariosSection';
import CasesSection from './components/CasesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SEOSchema from '@/components/feature/SEOSchema';

const faqData = [
  {
    question: '什么是无码平台？和传统开发有什么区别？',
    answer: '无码平台是一种可视化应用开发工具，允许用户通过拖拽组件、配置参数的方式快速构建软件应用，无需编写代码。相比传统开发模式（数周至数月），无码开发可以将开发周期缩短至数天甚至数小时，同时大幅降低对专业技术人员的依赖，让业务人员也能直接参与应用搭建。',
  },
  {
    question: '无码平台适合哪些场景？有没有功能限制？',
    answer: '无码平台适用于企业管理系统（CRM、ERP、OA）、数据收集与分析、自动化工作流、企业官网与电商平台等多种场景。对于复杂的定制化需求，平台也提供了开放API和自定义代码扩展能力，确保在简化开发的同时不牺牲灵活性。绝大多数企业级应用需求都可以通过无码平台满足。',
  },
  {
    question: '使用无码开发的应用数据安全吗？',
    answer: '绝对安全。无码平台采用多重安全机制保障数据安全：数据传输全程加密（TLS 1.3）、数据库存储加密、RBAC精细权限控制、完整的操作审计日志。平台已通过ISO 27001信息安全管理体系认证，并支持私有化部署，满足金融、医疗等高合规要求行业的严格标准。',
  },
  {
    question: '无码平台支持哪些终端？可以生成APP吗？',
    answer: '无码平台支持一次设计、多端运行。你搭建的应用可以同时在PC端（Web）、移动端（H5响应式）、平板端上使用，还可以一键生成微信小程序。对于需要发布到应用商店的原生APP需求，平台也提供了PWA（渐进式Web应用）打包方案，用户可以将应用添加到手机桌面，获得接近原生APP的体验。',
  },
  {
    question: '如何开始使用无码？需要培训吗？',
    answer: '注册后即可免费开始使用。平台提供丰富的模板库和图文教程，大多数人可以在10分钟内完成第一个应用的搭建。对于企业用户，我们还提供专属的客户成功经理一对一指导、在线培训课程和定期的产品更新培训。您也可以随时查阅帮助文档或联系在线客服获取支持。',
  },
  {
    question: '无码平台的定价是怎样的？',
    answer: '无码提供灵活的定价方案：个人版完全免费，适合学习和小型项目；专业版按用户数收费，提供更多功能和资源额度；企业版支持私有化部署、定制化开发和专属服务。具体价格请通过官网联系我们的商务团队，我们将根据您的实际需求提供最合适的方案。',
  },
];

export default function Home() {
  useEffect(() => {
    document.title = '无码 - 新一代低代码无码开发平台 | 快速搭建应用与自动化流程';
  }, []);

  return (
    <>
      <SEOSchema
        pageType="homepage"
        pageTitle="无码 - 新一代低代码无码开发平台"
        pageDescription="无码帮助企业和个人无需编写代码即可快速搭建应用、自动化流程与数字化系统，极大降低开发门槛，提升业务效率。"
        canonicalPath="/"
        faqData={faqData}
      />
      <main>
        <HeroSection />
        <CapabilitiesSection />
        <ScenariosSection />
        <CasesSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}